import _ from 'lodash';

export default function SecurityGroupsViewUsersController(
  $state,
  $log,
  $scope,
  $rootScope,
  $filter,
  $uibModal,
  securityGroupsService,
  gettextCatalog,
) {
  'ngInject';

  $scope.userUrl = securityGroupsService.getUserUrl();
  //Pagination
  $scope.currentPage = 1;
  $scope.itemsPerPage = 20;
  $scope.maxSize = 3;

  $scope.searchText = '';
  $scope.previousSearchText = '';
  $scope.filteredUsers = $scope.group.users;

  //Sorting
  $scope.predicate = 'name'; //for ngsortby
  $scope.reverse = false;

  //Sort security group users
  $scope.orderSecurityGroupUsers = function (predicate) {
    if (predicate === $scope.predicate) {
      $scope.reverse = !$scope.reverse;
    } else {
      $scope.reverse = false;
    }
    $scope.predicate = predicate;
    GTM_AssetsChanged('securityUsersOrderChanged');
  };

  $scope.applyFilter = function (loading = false) {
    if (!loading && $scope.previousSearchText === $scope.searchText) return;
    $scope.filteredUsers = $filter('filter')($scope.group.users, $scope.searchText);
    $scope.previousSearchText = $scope.searchText;
    if (!loading) GTM_AssetsChanged('securityUsersFiltered');
  };

  $scope.openSelectModal = function () {
    var modalScope = $scope.$new();
    modalScope.modalTitle =
      gettextCatalog.getString('Select users for Security Group: ') + $scope.group.name;

    $scope.resetFlags();
    var modalInstance = $uibModal.open({
      animation: $scope.animationsEnabled,
      template: require('./users-modal/users.modal.html'),
      controller: 'SecurityGroupViewUserSelectionModalController',
      size: 'lg',
      scope: modalScope,
      resolve: {
        singleSelect: false,
        selectedUsers: function () {
          var selected = {};

          if ($scope.group.users) {
            for (var i = 0; i < $scope.group.users.length; i++) {
              var e = $scope.group.users[i];
              selected[e.id] = e;
            }
          }
          return selected;
        },
      },
    });

    modalInstance.result.then(
      function (selectedUsers) {
        var changeSet = [];

        //If the selectedusers are not already in the groups users list then an add entry must be added to the changeset
        for (var key in selectedUsers) {
          if (
            !_.find($scope.group.users, function (e) {
              return key == e.id;
            })
          ) {
            changeSet.push({
              op: 'add',
              value: {
                user: $scope.userUrl + key,
              },
            });
          }
        }

        //If the selected user was in the previous group, but is not in the newly selectd list of users..then we need to remove it in the changeset
        _.forEach($scope.group.users, function (existingUser) {
          if (
            !_.find(selectedUsers, function (selectedUser) {
              return selectedUser.id == existingUser.id;
            })
          ) {
            changeSet.push({
              op: 'remove',
              value: {
                user: $scope.userUrl + existingUser.id,
              },
            });
          }
        });

        $scope.submitUsers(_.values(selectedUsers), changeSet);
      },
      function () {
        $log.info(
          gettextCatalog.getString('Modal dismissed at: {{date}}', {
            date: new Date(),
          }),
        );
      },
    );
  };

  //Remove all of the selected users
  $scope.removeSelected = function () {
    var newUserList = _.filter($scope.group.users, function (e) {
      return !e.selected;
    });

    var changeSet = _.map(
      _.filter($scope.group.users, function (e) {
        return e.selected;
      }),
      function (selectedUser) {
        return {
          op: 'remove',
          value: {
            user: $scope.userUrl + selectedUser.id,
          },
        };
      },
    );

    $scope.submitUsers(newUserList, changeSet);
  };

  $scope.submitUsers = function (newUserList, changeset) {
    $scope.errorFlag = false;
    var data = changeset;
    if (changeset.length == 0 || $scope.sending) {
      return;
    }
    $scope.sending = true;

    securityGroupsService
      .patchEquipmentUserUpdate($scope.securityGroupId, data)
      .then(
        function (response) {
          if (newUserList) {
            $scope.group.users = newUserList;
            $scope.applyFilter(true);
          }
          $scope.errorFlag = false;
          $scope.checkMembership();
        },
        function (error) {
          var errorMsg = gettextCatalog.getString('An error occurred while editing users');
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg =
                error.data.message +
                ' ' +
                (error.status.toString() + ' - ' + error.statusText.toString());
            } else {
              errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          $scope.errorText = errorMsg;
          $scope.errorFlag = true;
        },
      )
      .finally(function () {
        $scope.sending = false;
      });
    return true;
  };

  $scope.checkMembership = function () {
    //if a user is discretionary and has removed themselves from the group, kick them back to the group list (this group effectively no longer exists for them)
    if ($rootScope.currentUser.securityMode !== 'Discretionary') {
      return;
    }

    //Check to see if we still in the group and have not removed ourself.  If so, do nothing and return
    if (
      _.find($scope.group.users, function (e) {
        return e.id == $rootScope.currentUser.id;
      })
    )
      return;

    $state.go('admin.securitygroups', {
      create: false,
      deleted: false,
      selfRemoved: true,
    });
  };

  $scope.dropdownEvents = {
    onItemSelect: $scope.updateOnSelect,
    onItemDeselect: $scope.updateOnDropdownRemove,
    onSelectAll: $scope.updateOnSelectAll,
    onDeselectAll: $scope.updateOnRemoveAll,
  };

  $scope.isAllUsersSelected = function () {
    return !_.find($scope.group.users, function (e) {
      return !e.selected;
    });
  };

  $scope.numSelectedUsers = function () {
    return _.filter($scope.group.users, function (e) {
      return e.selected;
    }).length;
  };

  $scope.selectAllUsers = function () {
    var flag = !$scope.isAllUsersSelected();
    _.forEach($scope.group.users, function (e) {
      e.selected = flag;
    });

    GTM_AssetsChanged(flag ? 'securityUsersAllSelected' : 'securityUsersAllDeselected');
  };

  $scope.toggleUser = function (user) {
    user.selected = !user.selected;

    GTM_AssetsChanged(user.selected ? 'securityUserSelected' : 'securityUserDeselected');
  };

  $scope.pageChanged = function () {
    GTM_AssetsChanged('securityUsersPageChanged');
  };

  function GTM_AssetsChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.group.users.length,
        totalFiltered: $scope.filteredUsers.length,
        totalSelected: $scope.numSelectedUsers(),
        pageNumber: $scope.currentPage,
        orderBy: $scope.predicate,
        sortDirection: $scope.reverse ? 'descending' : 'ascending',
      },
    });
  }
}
